import React, { useCallback } from 'react';
import { push } from 'connected-react-router';
import { store } from '../../store';
import { put } from '../../services/api';
import Button from '../../common/Button';
import { OFF_WALL_PARTICIPANT, OFF_WALL_ROLES } from '../../utils/user-util';

export default function OffCameraModeButton({ notesData, onClick, style }) {
  const _handleOnClick = useCallback(async () => {
    const { eventParticipantId } = notesData;
    await put(`/eventParticipant/${eventParticipantId}`, { role: OFF_WALL_PARTICIPANT });
    
    store.dispatch(push({ pathname: '/connect', state: {...notesData, role: OFF_WALL_PARTICIPANT}, search: window.location.search }));
  }, [notesData, onClick]);

  if ((notesData && notesData.event.allowOffWallSelfElection === true) || OFF_WALL_ROLES.includes(notesData.role)) {
    return <Button type='secondary' text={'Off-Camera Mode'} onClick={_handleOnClick} containerStyle={style} />;
  }

  return null;
}
